import { ReactNode } from 'react';

import classNames from 'classnames';

export type TextHighlightColors =
  | 'cyan'
  | 'magenta'
  | 'yellow'
  | 'green'
  | 'gray'
  | 'blue'
  | 'black'
  | 'purple'
  | 'orange';

interface TextHighlightProps {
  color?: TextHighlightColors;
  children?: ReactNode;
}

export function TextHighlight({
  color = 'magenta',
  children,
}: TextHighlightProps) {
  return (
    <span
      className={classNames('inline shadow-[inset_0_-0.4em_0]', {
        'shadow-cyan-200 dark:shadow-cyan-700': color === 'cyan',
        'shadow-magenta-200 dark:shadow-magenta-700': color === 'magenta',
        'shadow-yellow-400 dark:shadow-yellow-700': color === 'yellow',
        'shadow-green-100 dark:shadow-green-700': color === 'green',
        'shadow-gray-200 dark:shadow-gray-700': color === 'gray',
        'shadow-blue-200 dark:shadow-blue-700': color === 'blue',
        'shadow-black dark:shadow-gray-700': color === 'black',
        'shadow-purple-200 dark:shadow-purple-700': color === 'purple',
        'shadow-orange-200 dark:shadow-orange-700': color === 'orange',
      })}
    >
      {children}
    </span>
  );
}
